import { FuseAuthProviderState } from '@fuse/core/FuseAuthProvider/types/FuseAuthTypes';
import { User } from '@auth/user';
import { createContext } from 'react';

export type SupabaseSignInPayload = {
	email: string;
	password: string;
};

export type SupabaseAuthContextType = FuseAuthProviderState<User> & {
	updateUser: (U: User) => Promise<Response>;
	signIn?: (credentials: SupabaseSignInPayload) => Promise<{ user: User } | null>;
	signOut?: () => void;
};

const defaultAuthContext: SupabaseAuthContextType = {
	authStatus: 'configuring',
	isAuthenticated: false,
	user: null,
	updateUser: null,
	signIn: null,
	signOut: null
};

const SupabaseAuthContext = createContext<SupabaseAuthContextType>(defaultAuthContext);

export default SupabaseAuthContext;
